import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueHammer } from 'vue2-hammer'
import BackgroundImage from '@/js/plugins/background-image'
import '@/js/plugins/lang.filter.js'

Vue.config.productionTip = false

Vue.use(VueHammer)
Vue.use(BackgroundImage)

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
